import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AVSLogger } from '@avss-tech/logger';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private logger: AVSLogger;
  logs: any = environment?.avsLogger;
  apiUrl: any = environment?.apiUrl;

  constructor(private http: HttpClient) {
    this.logger = new AVSLogger({
      project: this.logs.project,
      apiKey: this.logs.key,
      endpoint: this.logs?.url,
      onFatalError: (error) => {
        console.error('AVS Logger Fatal Error:', error);
      }
    });
  }

  dashboard(): any {
    return this.http.get(`${this.apiUrl}/admin/analytics/dashboard`);
  }

  getStampDashboardData() {
    return this.http.get(`${this.apiUrl}/bulk-estamp/admin/dashboard`)
  }

  getAnalyticsRevenue(): any {
    return this.http.get(`${this.apiUrl}/admin/analytics/revenue`);
  }

  getMonthlyDocStatus(date:any): any {
    return this.http.get(`${this.apiUrl}/admin/analytics/documents/${date}`)
  }

  getLogger(): AVSLogger {
    return this.logger;
  }

  getStatistics() {
    return this.logger.getStatistics();
  }

  getAccessLogs(data: any): any {
    return this.logger.getAccessLogs(data.limit, this.logs?.project);
  }

}


